import React from 'react';
import styled from 'styled-components';
import StyledBackground from '../components/auth/StyledBackground';
import StyledCardContainer from '../components/auth/StyledCardContainer';
import LoginForm from '../components/auth/LoginForm';
import { useAuth } from '../utils';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate(); // 初始化 useNavigate
  const handleLogout = () => {
    logout();
    navigate('/'); // 導向首頁
  };

  return (
    <StyledBackground>
      <StyledCardContainer>
        {isAuthenticated ? (
          <>
            <h2>Welcome!</h2>
            <h3>You are logged in.</h3>
            <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
          </>
        ) : (
          <>
            <h2>Login</h2>
            <h3>Enter your credentials</h3>
            <LoginForm />
          </>
        )}
      </StyledCardContainer>
    </StyledBackground>
  );
};

const LogoutButton = styled.button`
  cursor: pointer;
  padding: 10px 20px;
  background: #ff3333;
  color: #fff;
  border: 0;
  border-radius: 6px;
  font-size: 16px;
`;

export default LoginPage;
